// store/MenuStore.ts
import { makeAutoObservable } from 'mobx';

class MenuStore {
  isVisible: boolean = true;
  backgroundColor: string = 'white';
  isDarkMode: boolean = false; // ✅ 다크 모드 여부 상태 추가
  currentSection: string = '';
  isAttacted: boolean = true;
  mobileActiveOpenMenu: string[] = []
  isOpen: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  show() {
    this.isVisible = true;
  }

  hide() {
    this.isVisible = false;
  }

  attach() {
    this.isAttacted = true;
  }

  remove() {
    this.isAttacted = false;
  }

  toggle() {
    this.isVisible = !this.isVisible;
  }

  setBackgroundColor(color: string) {
    this.backgroundColor = color;
  }

  setDarkMode(value: boolean) {
    this.isDarkMode = value;
  }

  toggleDarkMode() {
    this.isDarkMode = !this.isDarkMode;
  }

  setCurrentSection(value: string) {
    this.currentSection = value;
  }

  setMobileActiveOpenMenu(openMenus: string[]) {
    this.mobileActiveOpenMenu = openMenus;
  }

  setOpen(isOpen: boolean) {
    this.isOpen = isOpen;
  }
}

const menuStore = new MenuStore();
export default menuStore;
